export class JobProgressStep {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "JobProgressStepKind",
            "format": ""
        },
        {
            "name": "ordinal",
            "baseName": "ordinal",
            "type": "number",
            "format": ""
        },
        {
            "name": "parentStepId",
            "baseName": "parentStepId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "essential",
            "baseName": "essential",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "JobProgressStepStatus",
            "format": ""
        },
        {
            "name": "derivedStatus",
            "baseName": "derivedStatus",
            "type": "JobProgressStepStatus",
            "format": ""
        },
        {
            "name": "errorCode",
            "baseName": "errorCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "userMessage",
            "baseName": "userMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "helpUrlKey",
            "baseName": "helpUrlKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endedAt",
            "baseName": "endedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "derivedEndedAt",
            "baseName": "derivedEndedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createInstance",
            "baseName": "createInstance",
            "type": "JobProgressStepCreateInstanceData",
            "format": ""
        },
        {
            "name": "restoreVolume",
            "baseName": "restoreVolume",
            "type": "JobProgressStepRestoreVolumeData",
            "format": ""
        },
        {
            "name": "volumeCreation",
            "baseName": "volumeCreation",
            "type": "JobProgressStepVolumeCreationData",
            "format": ""
        },
        {
            "name": "connectingToRestoreServer",
            "baseName": "connectingToRestoreServer",
            "type": "JobProgressStepConnectingToRestoreServerData",
            "format": ""
        },
        {
            "name": "bucketDataRestoration",
            "baseName": "bucketDataRestoration",
            "type": "JobProgressStepBucketDataRestorationData",
            "format": ""
        },
        {
            "name": "restoreWorker",
            "baseName": "restoreWorker",
            "type": "JobProgressStepRestoreWorkerData",
            "format": ""
        },
        {
            "name": "scanningBucket",
            "baseName": "scanningBucket",
            "type": "JobProgressStepScanningBucketData",
            "format": ""
        },
        {
            "name": "bucketDataBackup",
            "baseName": "bucketDataBackup",
            "type": "JobProgressStepBucketDataBackupData",
            "format": ""
        },
        {
            "name": "databaseClusterCreation",
            "baseName": "databaseClusterCreation",
            "type": "JobProgressStepDatabaseClusterCreationData",
            "format": ""
        },
        {
            "name": "databaseDataRestoration",
            "baseName": "databaseDataRestoration",
            "type": "JobProgressStepDatabaseDataRestorationData",
            "format": ""
        },
        {
            "name": "progress",
            "baseName": "progress",
            "type": "StepProgressView",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStep.attributeTypeMap;
    }
    constructor() {
    }
}
